import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const menuApi = createApi({
    reducerPath: "base/menu",
    baseQuery: axiosBaseQuery,
    tagTypes: ["menuList"],
    endpoints: (builder) =>({
        menuFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['menuList'],
            query: (query = '') => ({
                url: "/base/menu" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        menuCreate: builder.mutation({
            invalidatesTags: ['menuList'],
            query: (data)=>({url: "/base/menu", method: "POST", data})
        }),
        menuUpdate: builder.mutation({
            invalidatesTags: ['menuList'],
            query: (data)=>({url: "/base/menu/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        menuDelete: builder.mutation({
            invalidatesTags: ['menuList'],
            query: (id)=>({url: "/base/menu/"+id, method: "DELETE"})
        }),
    })
})

export const { useMenuFindAllQuery, useMenuCreateMutation, useMenuUpdateMutation, useMenuDeleteMutation } = menuApi;
export {menuApi};
